module.exports = __webpack_public_path__ + "img/94.5b3b8614.png";